import { STATUS_TYPE } from '../../../enum';

export interface CreateChangeAdvertiseStatus {
  advertiseId: string;
  status?: string; // Make optional since extend expiry doesn't need status
  startDate?: Date | string;
  endDate?: Date | string; // Accept both Date and string (ISO format)
  rejectionReason?: string;
}

export interface ChangeAdvertiseStatus {
  id: string;
  advertiseId: string;
  status: string;
  startDate?: Date;
  endDate?: Date;
  rejectionReason?: string;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: ChangeAdvertiseStatus[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
